import request from '../request'
import apis from '../apis'

export default {

    /**
     * 火车票搜索
     * @param {*} param
     */
    getTrainData({ param, pageVO }) {
        return request.get(`${apis.GET_TRAIN_DATA}/${pageVO.pageSize}/${pageVO.curPage}`, { params: param });
    },

    /**
     * 火车票新增
     * @param {*} param
     */
    addTrainData(param) {
        return request.post(`${apis.ADD_TRAIN_DATA}`, param)
    },

    /**
     * 火车票编辑
     * @param {*} param
     */
    editTrainData(param) {
        return request.post(`${apis.EDIT_TRAIN_DATA}`, param)
    },

    /**
     * 火车票查看详情
     * @param {*} param
     */
    getTrainDetail(param) {
        return request.get(`${apis.GET_TRAIN_DETAIL}`, { params: param });
    },

    /**
     * 火车票 删除
     * @param {*} param
     */
    deleteTrainData(param) {
        return request.post(`${apis.DELETE_TRAIN_DATA}`, param)
    },

    /**
     * 机票搜索
     * @param {*} param
     */
    getPlaneData({ param, pageVO }) {
        return request.get(`${apis.GET_PLANE_DATA}/${pageVO.pageSize}/${pageVO.curPage}`, { params: param });
    },

    /**
     * 机票新增
     * @param {*} param
     */
    addPlaneData(param) {
        return request.post(`${apis.ADD_PLANE_DATA}`, param)
    },

    /**
     * 机票编辑
     * @param {*} param
     */
    editPlaneData(param) {
        return request.post(`${apis.EDIT_PLANE_DATA}`, param)
    },

    /**
     * 机票查看详情
     * @param {*} param
     */
    getPlaneDetail(param) {
        return request.get(`${apis.GET_PLANE_DETAIL}`, { params: param });
    },

    /**
     * 机票 删除
     * @param {*} param
     */
    deletePlaneData(param) {
        return request.post(`${apis.DELETE_PLANE_DATA}`, param)
    },

    /**
     * 休闲资源搜索
     * @param {*} param
     */
    getLeisureData({ param, pageVO }) {
        return request.get(`${apis.GET_LEISURE_DATA}/${pageVO.pageSize}/${pageVO.curPage}`, { params: param });
    },

    /**
     * 休闲资源新增
     * @param {*} param
     */
    addLeisureData(param) {
        return request.post(`${apis.ADD_LEISURE_DATA}`, param)
    },

    /**
     * 休闲资源编辑
     * @param {*} param
     */
    editLeisureData(param) {
        return request.post(`${apis.EDIT_LEISURE_DATA}`, param)
    },

    /**
     * 休闲资源查看详情
     * @param {*} param
     */
    getLeisureDetail(param) {
        return request.get(`${apis.GET_LEISURE_DETAIL}`, { params: param });
    },

    /**
     * 休闲资源 删除
     * @param {*} param
     */
    deleteLeisureData(param) {
        return request.post(`${apis.DELETE_LEISURE_DATA}`, param)
    },

    /**
     * 获取推荐机票数据
     * @param {*} params
     */
    getHotTicketData(params) {
        return request.get(apis.GET_HOT_TICKET, { params });
    },

    /**
     * 获取推荐火车票数据
     * @param {*} params
     */
    getHotTrainTicketData(params) {
        return request.get(apis.GET_HOT_TRAIN_TICKET, { params });
    },

    /**
     * 获取推荐机休闲资源数据
     * @param {*} params
     */
    getHotLeisureResourcesData(params) {
        return request.get(apis.GET_HOT_LEISURE_RESOURCES, { params });
    },

    /**
     * 休闲资源类型 lookup
     * @param {*} params
     */
    getLeisureType(params) {
        return request.get(apis.GET_LEISURE_TYPE)
    }
}
